var parent = require('../../es/object/set-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/set-prototype-of.js
// module id = 1022
// module chunks = 0